export default {
      id: "phone-usage",
      viewBox: "0 0 513.64 513.64",
      url: "../../assets/" + "sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }